<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>宿舍管理</el-breadcrumb-item>
      <el-breadcrumb-item>房态管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin: 15px; min-height: calc(100vh - 111px)">
      <!-- 统计卡片 -->
      <el-row :gutter="20" style="margin-bottom: 15px;">
        <el-col :span="4" v-for="(stat, key) in statistics" :key="key">
          <el-card shadow="hover" :body-style="{ padding: '10px' }">
            <div style="text-align: center;">
              <div style="font-size: 12px; color: #909399;">{{ stat.label }}</div>
              <div style="font-size: 20px; font-weight: bold;">{{ stat.value }}</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 筛选区 -->
      <div style="margin: 10px 0; display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
        <el-select v-model="filterBuild" clearable placeholder="按楼栋筛选" @change="filterRooms">
          <el-option v-for="item in buildOptions" :key="item" :label="item + '号楼'" :value="item" />
        </el-select>
        <el-select v-model="filterFloor" clearable placeholder="按楼层筛选" @change="filterRooms">
          <el-option v-for="item in floorOptions" :key="item" :label="item + '层'" :value="item" />
        </el-select>
        <el-select v-model="filterType" clearable placeholder="按类型筛选" @change="filterRooms">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button icon="refresh-left" @click="resetFilter">重置</el-button>
      </div>

      <!-- 图例 -->
      <div style="margin: 10px 0; display: flex; gap: 15px; align-items: center; flex-wrap: wrap;">
        <div v-for="item in colorLegend" :key="item.color" style="display: flex; align-items: center; gap: 5px;">
          <div :style="{ width: '16px', height: '16px', backgroundColor: item.color, borderRadius: '3px', border: '1px solid #dcdfe6' }"></div>
          <span style="font-size: 12px;">{{ item.label }}</span>
        </div>
      </div>

      <!-- 房间卡片展示 -->
      <div v-for="build in groupedRooms" :key="build.buildId" style="margin-bottom: 20px;">
        <h3 style="margin: 10px 0; border-left: 4px solid #409EFF; padding-left: 10px;">{{ build.buildId }}号楼</h3>
        <div v-for="floor in build.floors" :key="floor.floorNum" style="margin-bottom: 15px;">
          <div style="font-weight: bold; margin-bottom: 8px; color: #606266;">{{ floor.floorNum }}层</div>
          <el-row :gutter="10">
            <el-col :span="3" v-for="room in floor.rooms" :key="room.dormRoomId" style="margin-bottom: 10px;">
              <el-card
                shadow="hover"
                :body-style="{ padding: '8px', cursor: 'pointer', backgroundColor: room.displayColor || '#ffffff' }"
                @click="handleRoomClick(room)"
              >
                <div style="text-align: center;">
                  <div style="font-weight: bold; font-size: 14px;">{{ room.dormRoomId }}</div>
                  <div style="font-size: 12px; margin-top: 4px; color: #606266;">
                    <el-tag v-if="room.roomType" size="small" :type="room.roomType === 'normal' ? 'info' : 'warning'">{{ room.typeLabel }}</el-tag>
                  </div>
                  <div v-if="room.problemNote" style="font-size: 11px; margin-top: 4px; color: #909399;" class="text-ellipsis">{{ room.problemNote }}</div>
                  <div style="font-size: 11px; margin-top: 4px;">
                    <el-tag v-if="room.bookingStatus === 1" size="small" type="primary">已预订</el-tag>
                    <el-tag v-else-if="room.currentCapacity > 0" size="small" type="danger">在住</el-tag>
                    <el-tag v-else size="small" type="success">空闲</el-tag>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 房间详情弹窗 -->
      <el-dialog v-model="roomDialogVisible" title="房间详情" width="30%" @close="cancelRoom">
        <el-form ref="roomForm" :model="roomForm" label-width="120px">
          <el-form-item label="房间号">
            <el-input v-model="roomForm.dormRoomId" disabled style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="楼栋号">
            <el-input v-model="roomForm.dormBuildId" disabled style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="楼层">
            <el-input v-model="roomForm.floorNum" disabled style="width: 80%"></el-input>
          </el-form-item>
          <!-- 入住人信息 -->
          <el-form-item label="入住人数">
            <el-tag type="info">{{ roomForm.currentCapacity }}/{{ roomForm.maxCapacity }}人</el-tag>
          </el-form-item>
          <el-form-item label="床位详情">
            <div style="width: 100%;">
              <div v-for="(bed, index) in roomBeds" :key="index" style="display: flex; align-items: center; margin-bottom: 8px; padding: 5px; background: #f5f7fa; border-radius: 4px;">
                <span style="width: 60px; color: #606266;">床位{{ index + 1 }}:</span>
                <span v-if="bed.username" style="flex: 1;">
                  <el-tag size="small" type="success">{{ bed.username }}</el-tag>
                  <span v-if="bed.name" style="margin-left: 5px; color: #409EFF;">{{ bed.name }}</span>
                </span>
                <span v-else style="flex: 1; color: #909399;">空闲</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="房间类型">
            <el-select v-model="roomForm.roomType" placeholder="选择类型" style="width: 80%" @change="handleTypeChange">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="颜色标记">
            <el-color-picker v-model="roomForm.roomColor" show-alpha @change="handleColorChange"></el-color-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="roomForm.problemNote" type="textarea" rows="3" style="width: 80%"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="cancelRoom">取 消</el-button>
            <el-button type="primary" @click="saveRoom">保 存</el-button>
          </span>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>
<script src="@/assets/js/RoomStatus.js"></script>
<style scoped>
@import '../assets/css/RoomStatus.css';
</style>
